module.exports = __webpack_public_path__ + "static/img/后视镜.861f004.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue11/05/后视镜.jpg
// module id = yTfN
// module chunks = 7